import Section from './section';

export default class Publication {
  date_created?: string;
  disabled?: boolean;
  icon_set_id?: string;
  id?: string;
  json_url?: string;
  last_updated?: string;
  layout: {type: string};
  readonly?: boolean;
  rss_url?: string;
  screenshot_url?: string;
  sections: Section[];
  title: string;
  type?: number;
  url?: string;
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/publication.ts